<template>
  <div
    id="kt_header"
    class="header align-items-stretch"
    style="background: #fff;border-bottom: 1px solid #E9E9EF;"
  >
    <div class="container d-flex align-items-center justify-content-between py-3">
      <router-link :to="{ name: 'my-exam' }">
        <img
          alt="Logo"
          src="media/icon-app/newlogo1.png"
          class="h-40px"
          style="max-width: 100%; object-fit: contain;"
        />
      </router-link>

      <div
        v-if="userInfo"
        class="d-flex align-items-center position-relative"
        ref="menuRoot"
      >
        <div
          class="btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px"
          style="position: relative;cursor: pointer;"
          @click="toggleMenu"
        >
          <img
            :src="userInfo.imageProfile ? userInfo.imageProfile : 'media/avatars/blank.png'"
            alt="avatar"
            style="object-fit:cover;border-radius: 50%;width:100%;height:100%;"
            @error="setAltImg"
          />

          <div
            v-if="userMandatory != null && userMandatory == 2"
            class="mandatory-badge bg-success"
            data-label="ผ่านการยืนยัน"
          ><i class="fa fa-check" style="color: white;"></i></div>
          <div
            v-else-if="userMandatory == 1"
            class="mandatory-badge bg-warning"
            data-label="รออนุมัติ"
          ><i class="fa fa-clock" style="color: white;"></i></div>
          <div
            v-else-if="userMandatory == 0 || userMandatory == null || userMandatory == 3"
            class="mandatory-badge bg-danger"
            data-label="ยังไม่ยืนยัน"
          ><i class="fa fa-times" style="color: white;"></i></div>
        </div>
        <span
          class="d-none d-lg-block mx-2"
          style="min-width: 0; max-width: 200px;cursor: pointer;"
          @click="toggleMenu"
        >
          <b style="display: block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ userInfo.firstName + " " + userInfo.lastName }}</b>
          <span style="display: block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 12px; color: #9ca3af;">{{ userInfo.email }}</span>
        </span>

        <div
          v-if="menuOpen"
          class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold py-4 fs-6 w-275px"
          style="display: flex !important;position: absolute;right: 0;top: 100%;margin-top: 8px;background: #fff;border-radius: 8px;box-shadow: 0 0 20px rgba(0,0,0,0.1);z-index: 105;"
        >
          <div class="menu-item px-3">
            <div class="menu-content d-flex align-items-center px-3">
              <div class="symbol symbol-50px me-5">
                <img
                  alt="Logo"
                  :src="userInfo.imageProfile ? userInfo.imageProfile : 'media/avatars/blank.png'"
                  style="object-fit:cover"
                  @error="setAltImg"
                />
              </div>
              <div class="d-flex flex-column">
                <div class="fw-bolder d-flex align-items-center fs-5">
                  {{ userInfo.firstName }} {{ userInfo.lastName }}
                </div>
                <a href="#" class="fw-bold text-muted text-hover-primary fs-7">
                  {{ userInfo.email }}
                </a>
              </div>
            </div>
          </div>

          <div class="separator my-2"></div>

          <div class="menu-item px-5">
            <a @click="signOut()" class="menu-link px-5" style="color:#FF7786;cursor:pointer;">
              ออกจากระบบ
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, onBeforeUnmount } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import axios from "axios";
import { Actions } from "@/store/enums/StoreEnums";

export default defineComponent({
  name: "HeaderSimple",
  setup() {
    const store = useStore();
    const router = useRouter();
    const menuOpen = ref(false);
    const menuRoot = ref<HTMLElement | null>(null);
    const userMandatory = ref<number | null>(null);

    let userInfo: any = null;
    try {
      userInfo = JSON.parse(localStorage.getItem("userInfo") || "null");
    } catch (error) {
      userInfo = null;
    }
    if (userInfo && userInfo.imageProfile) {
      if (userInfo.imageProfile.indexOf("http") == -1) {
        userInfo.imageProfile = process.env.VUE_APP_IMG_URL + userInfo.imageProfile;
      }
    }

    if (localStorage.getItem("id_token") != null) {
      axios
        .get(
          process.env.VUE_APP_API_URL + "/getProfile?id=" + localStorage.getItem("u_id"),
          {
            headers: {
              token: localStorage.getItem("id_token"),
            },
          },
        )
        .then((response) => {
          userMandatory.value = response.data.data.currentSpecialistStatus;
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            localStorage.removeItem("id_token");
            location.reload();
          }
        });
    }

    const toggleMenu = () => {
      menuOpen.value = !menuOpen.value;
    };

    const onClickOutside = (e: MouseEvent) => {
      if (menuRoot.value && !menuRoot.value.contains(e.target as Node)) {
        menuOpen.value = false;
      }
    };

    onMounted(() => {
      document.addEventListener("click", onClickOutside);
    });
    onBeforeUnmount(() => {
      document.removeEventListener("click", onClickOutside);
    });

    const signOut = () => {
      const isIdCardLogin = localStorage.getItem("typeLogin") === "idcard";
      store.dispatch(Actions.LOGOUT).then(() =>
        router.push({ name: isIdCardLogin ? "sign-in-idcard" : "sign-in" }),
      );
    };

    return {
      userInfo,
      userMandatory,
      menuOpen,
      menuRoot,
      toggleMenu,
      signOut,
    };
  },
  methods: {
    setAltImg(event: Event) {
      (event.target as HTMLImageElement).src = "media/avatars/blank.png";
    },
  },
});
</script>

<style scoped>
.mandatory-badge {
  position: absolute;
  bottom: -3px;
  right: -3px;
  width: 14px;
  height: 14px;
  font-size: 8px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: default;
}
.mandatory-badge::after {
  content: attr(data-label);
  position: absolute;
  bottom: 18px;
  right: 0;
  background: rgba(0,0,0,0.75);
  color: #fff;
  font-size: 11px;
  white-space: nowrap;
  padding: 3px 7px;
  border-radius: 4px;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s;
}
.mandatory-badge:hover::after {
  opacity: 1;
}
</style>
